import * as React from 'react';
import StandardCookie from '../../containers/CookieNotification/StandardCookie';
import GDPRCookie from '../../containers/CookieNotification/GDPRCookie';

const CookieNotification = () => {
	return (
		<>
			<StandardCookie />
			<GDPRCookie />
		</>
	);
};

export default CookieNotification;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieNotification/index.tsx